import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, browserCountry, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const BLANK = () => ({ suburb: "", postcode: "", state: "", country: browserCountry(), radius_km: 25 });

export const LocationDialog = ({ open, setOpen, initial, onSaved }) => {
  const [f, setF] = useState(BLANK());
  useEffect(() => { if (open) setF({ ...BLANK(), ...Object.fromEntries(Object.entries(initial || {}).filter(([k, v]) => v != null && v !== "" && ["suburb", "postcode", "state", "country", "radius_km"].includes(k))) }); }, [open]); // eslint-disable-line
  const save = async () => {
    try { const { data } = await api.put("/me/location", f); toast.success(data.area?.country_code ? `Location set: ${[data.area.city, data.area.region, data.area.country].filter(Boolean).join(", ")}` : "Saved — we couldn't place that exactly"); setOpen(false); onSaved?.(data); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="location-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl font-medium">Your general location</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Used for local and national news in Facts and for weather.</p>
        <div className="grid grid-cols-2 gap-2">
          <Input data-testid="loc-suburb-input" placeholder="Suburb / town" value={f.suburb} onChange={(e) => setF({ ...f, suburb: e.target.value })} />
          <Input data-testid="loc-postcode-input" placeholder="Postcode / ZIP" value={f.postcode} onChange={(e) => setF({ ...f, postcode: e.target.value })} />
          <Input data-testid="loc-state-input" placeholder="State / region" value={f.state} onChange={(e) => setF({ ...f, state: e.target.value })} />
          <Input data-testid="loc-country-input" placeholder="Country" value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} />
        </div>
        <p className="text-xs text-slate-500">We only store an approximate point (about 1 km). Your exact location is never shown to anyone.</p>
        <Button data-testid="loc-save-btn" disabled={!f.country.trim() && !f.suburb.trim()} onClick={save}>Save location</Button>
      </DialogContent>
    </Dialog>
  );
};
